/**
 * Determines the icon color for a step based on its enabled and completion states.
 *
 * @param {boolean} enabled - Whether the step is enabled
 * @param {boolean} isComplete - Whether the step is complete
 * @returns {string} CSS color value for the icon
 */
export const getStepIconColor = (enabled, isComplete) => {
	if (!enabled) {
		return 'var(--color-neutral-200)';
	}
	if (isComplete) {
		return 'var(--color-info-500)';
	}
	return 'var(--color-neutral-300)';
};
